if (!customElements.get("fulfillment-quantity-rule-message")) {
  class FulfillmentQuantityRuleMessage extends HTMLElement {
    constructor() {
      super();
      this.minimum = this.querySelector(".minimum");
      this.multiple = this.querySelector(".multiple");
      document.addEventListener(
        "on:variant:change",
        this.handleVariantChante.bind(this)
      );
    }

    handleVariantChante(event) {
      // console.log("event: ", event.detail);
      const quantityBreakProduct = event.detail.quantityBreakProduct;
      const selectedVariant = event.detail.variant;
      const selectedVariantData = event.detail.formatted[selectedVariant.id];
      // console.log("selectedVariantData: ", selectedVariantData);
      
      let minimum = 1;
      let multiple = 1;
      const quantityBreak = selectedVariantData.quantityBreak;
      const quantityRule = selectedVariantData.quantity_rule;

      if (quantityRule) {
        minimum = quantityRule.min;
        multiple = quantityRule.increment;
      } else if (quantityBreakProduct) {
        minimum = quantityBreakProduct.minimum;
        multiple = quantityBreakProduct.multiple;
      } else if (quantityBreak) {
        minimum = quantityBreak.minimum;
        multiple = quantityBreak.multiple;
      }
      this.minimum.innerHTML = minimum;
      this.multiple.innerHTML = multiple;
      if (minimum > 1) {
        this.classList.remove("hidden");
      } else {
        this.classList.add("hidden");
      }
    }
  }
  customElements.define(
    "fulfillment-quantity-rule-message",
    FulfillmentQuantityRuleMessage
  );
}
